import { render, staticRenderFns } from "./MessageBroad.vue?vue&type=template&id=7fd004ad&scoped=true&"
import script from "./MessageBroad.vue?vue&type=script&lang=js&"
export * from "./MessageBroad.vue?vue&type=script&lang=js&"
import style0 from "./MessageBroad.vue?vue&type=style&index=0&id=7fd004ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd004ad",
  null
  
)

export default component.exports